/**
 * @file Report the workstation's timezone so server-rendered PDFs print a
 * "Printed:" time that matches the clock on the wall.
 */

/**
 * @returns {string} IANA zone name (e.g. "America/Chicago"), or '' when the
 *   browser cannot resolve one — the server then falls back to Central.
 */
export function getClientTimeZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch {
    return '';
  }
}

/** Append the workstation timezone to report query params, when known. */
export function appendTimeZoneParam(params) {
  const tz = getClientTimeZone();
  if (tz) params.append('tz', tz);
  return params;
}
